import { NAV_INITIALIZE, NAV_ITEM_COUNT } from "../types";

export default function stickyNav(state = {}, action = {}) {
  switch (action.type) {
    case NAV_INITIALIZE: {
      return { ...state, ...action.data };
    }
    case NAV_ITEM_COUNT: {
      return { ...state, ...action.data };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stickyNavReducer.js